import { Pagination } from 'react-admin';
import React from 'react';

const PostPagination = (props) => (
  <Pagination rowsPerPageOptions={[5, 10, 25, 100, 500]} {...props} />
);

export default PostPagination;
